import { DateTimePickerComponent } from "@/components/shared/date-time-picker-modal/date-time-picker.component";
import Modal from "@/components/shared/modal/modal";
import { dxtToLocalServerTime } from "@dexteel/mesf-core";
import {
	Button,
	CircularProgress,
	IconButton,
	TextField,
} from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
// @flow
import * as React from "react";
import { useEffect, useState } from "react";

type Props = {
	value: Date | null;
	onChange: (val: Date | null) => void;
	title: string;
	disabled?: boolean;
	variant?: "outlined" | "filled" | "standard";
	error?: string;
	minDate?: Date;
	maxDate?: Date;
};

export const DateTimeFormField = ({
	value,
	onChange,
	disabled = false,
	title,
	variant = "standard",
	error,
	minDate,
	maxDate,
}: Props) => {
	const [showModal, setShowModal] = useState(false);
	const [internalValue, setInternalValue] = useState<Date | null>(value);

	useEffect(() => {
		if (showModal) {
			setInternalValue(value || null);
		}
	}, [showModal]);

	const onClick = () => {
		onChange(internalValue);
		setShowModal(false);
	};

	const onDeleteButtonClick = (ev: React.MouseEvent) => {
		ev.stopPropagation();
		ev.preventDefault();

		setInternalValue(null);
		onChange(null);
	};
	return (
		<>
			<TextField
				variant={variant}
				onClick={() => {
					!disabled && setShowModal(true);
				}}
				fullWidth
				disabled={disabled}
				value={value ? dxtToLocalServerTime(value, "yyyy-MM-dd HH:mm") : ""}
				InputLabelProps={{
					shrink: true,
				}}
				InputProps={{
					endAdornment: (
						<>
							{value && !disabled ? (
								<IconButton onClick={onDeleteButtonClick}>
									<DeleteIcon />
								</IconButton>
							) : null}
						</>
					),
				}}
				label={title}
				error={!!error}
				helperText={error}
			/>

			<Modal
				open={showModal}
				handleClose={() => {
					setShowModal(false);
				}}
				maxWidth="lg"
				id={title}
				title={title}
			>
				<Modal.Content>
					<DateTimePickerComponent
						value={internalValue}
						onChange={(date: Date) => setInternalValue(date)}
						minDate={minDate}
						maxDate={maxDate}
					/>
				</Modal.Content>
				<Modal.Actions>
					<Button
						fullWidth
						variant={"contained"}
						color={"primary"}
						onClick={onClick}
					>
						APPLY
					</Button>
				</Modal.Actions>
			</Modal>
		</>
	);
};
